var App = App || {};

App.MultiMenu = (function ($) {
    "use strict";

    const speed = 250;
    var hovering = false;

    var desktopLevel1 = $(".multi-menu-level-1.desktop > ul");
    var desktopLevel1Items = $(".multi-menu-level-1.desktop > ul").children("li").children("a, button");

    var desktopFocusable = [];
    var desktopFocusableWhich = 0;
    var desktopLevel2Items = $(".multi-menu-level-1.desktop .multi-menu-level-2").find("a, button");

    var sharedLevel2Triggers = $(".multi-menu-level-2 > ul > li > button");

    function Desktop() {

        $(".multi-menu-level-1.desktop").find(".multi-menu-level-2").each(function () {
            $(this).find("a").attr("tabindex", -2);
        });;

        desktopLevel1
            .on("mouseleave", function () {
                hovering = false;
                desktopLevel1Items.trigger("blur");
            })
            .on("keydown", function (e) {
                if (e.key === "Tab") {
                    hovering = false;
                    DesktopLevel2Close($(this).children("li").children("a, button"), 1);
                }
            });

        desktopLevel1Items
            .on("mouseenter", function () {
                DesktopLevel2Open($(this), hovering ? 1 : speed);
                hovering = true;
            })
            .on("focus", function () {
                DesktopLevel2Open($(this), 1);
                hovering = true;
            })
            .on("blur", function () {
                if (hovering === false) {
                    DesktopLevel2Close($(this), speed);
                }
            })
            .on("keydown", function (e) {
                if (e.key === "ArrowRight") {
                    e.preventDefault();
                    $(this).parent("li").next("li").children("a, button").trigger("focus");
                }
                else if (e.key === "ArrowLeft") {
                    e.preventDefault();
                    $(this).parent("li").prev("li").children("a, button").trigger("focus");
                }
                else if (e.key === "ArrowDown") {
                    hovering = true;
                    e.preventDefault();
                    desktopFocusable = [];
                    $(this).siblings(".multi-menu-level-2").find("a:visible, button:visible").each(function () { desktopFocusable.push(this); });
                    desktopFocusableWhich = 0;
                    $(desktopFocusable[desktopFocusableWhich]).trigger("focus");
                }
                else if (e.key === "Escape") {
                    var MenuuButton = $(this);
                    DesktopLevel2Close(MenuuButton, speed);
                }
            });

        desktopLevel2Items.on("keydown", function (e) {
            if (e.key === "ArrowRight") {
                hovering = true;
                e.preventDefault();
                $(this).parents(".multi-menu-level-2").parent("li").next("li").children("a, button").trigger("focus");
            }
            else if (e.key === "ArrowLeft") {
                hovering = true;
                e.preventDefault();
                $(this).parents(".multi-menu-level-2").parent("li").prev("li").children("a, button").trigger("focus");
            }
            else if (e.key === "ArrowDown") {
                hovering = true;
                e.preventDefault();
                if (desktopFocusableWhich < desktopFocusable.length - 1) { desktopFocusableWhich++; }
                else { desktopFocusableWhich = 0; }
                $(desktopFocusable[desktopFocusableWhich]).trigger("focus");
            }
            else if (e.key === "ArrowUp") {
                hovering = true;
                e.preventDefault();
                if (desktopFocusableWhich > 0) { desktopFocusableWhich--; }
                else { desktopFocusableWhich = desktopFocusable.length - 1; }
                $(desktopFocusable[desktopFocusableWhich]).trigger("focus");
            }
            else if (e.key === "Escape") {
                var MenuButton = $(this).parents(".multi-menu-level-2").siblings("a, button");
                DesktopLevel2Close(MenuButton, speed);
            }
        });
    }

    function Shared() {

        sharedLevel2Triggers.on("click", function () {

            const trigger = $(this);
            const triggerOthers = trigger.parent("li").siblings("li").children("a, button");

            if (trigger.attr("aria-expanded") === "true") {
                trigger.attr("aria-expanded", "false").siblings(".multi-menu-level-3").slideUp(speed);
                const removeFocasable = trigger.siblings(".multi-menu-level-3.desktop").find("a").toArray();
                desktopFocusable = desktopFocusable.filter(item => !removeFocasable.includes(item));
            }
            else {
                trigger.attr("aria-expanded", "true").siblings(".multi-menu-level-3").slideDown(speed);
                const insertFocusable = trigger.siblings(".multi-menu-level-3.desktop").find("a").toArray();
                const insertIndex = desktopFocusable.indexOf(trigger[0]) + 1;  
                desktopFocusable.splice(insertIndex, 0, ...insertFocusable);

                triggerOthers.attr("aria-expanded", "false").siblings(".multi-menu-level-3").slideUp(speed);
                const removeFocasable = triggerOthers.siblings(".multi-menu-level-3").find("a").toArray();
                desktopFocusable = desktopFocusable.filter(item => !removeFocasable.includes(item));

                desktopFocusableWhich = desktopFocusable.indexOf(trigger[0]);
            }
        });
    }

    function DesktopLevel2Open(Menu) {
        Menu.attr("aria-expanded", "true").siblings(".multi-menu-level-2").stop().removeAttr("style").slideDown(speed, function () { $(this).height("auto"); });
        DesktopLevel2Close(Menu.parents("li").siblings("li").children("a, button"), speed);
    }

    function DesktopLevel2Close(Menu) {
        Menu.attr("aria-expanded", "false").siblings(".multi-menu-level-2").stop().removeAttr("style").slideUp(speed, function () { $(this).removeAttr("style") });
    }

    function Mobile() {

        const menu = $(".multi-menu.mobile");
        const menuL1Focusable = [$(".site-header-mobile-trigger"), menu.find(".multi-menu-level-1"), menu.find(".multi-menu-utility"), menu.find(".multi-menu-footer")];
        const menuDropdown = menu.parents(".mobile-dropdown");

        menuDropdown
            .on("shown:zag:mobiledropown", function () {
                App.Base.FocusTrap(menu, false, menuL1Focusable);
            })
            .on("hidden:zag:mobiledropown", function () {
                App.Base.FocusTrap(menu, true, menuL1Focusable);
            });

        const level2Trigger = $(".multi-menu-level-1.mobile > ul > li > button");
        const level2Back = $(".multi-menu-level-2.mobile > button");
        let level2Menu = null;
        let level2MenuFocusable = null;

        level2Trigger.on("click", function () {

            const targetId = $(this).attr("aria-controls");
            level2Menu = $(`.multi-menu-level-2#${targetId}`);
            level2MenuFocusable = [level2Menu];

            menu.addClass("transition");
            setTimeout(function () { menu.removeClass("transition"); }, speed);

            level2Menu.show();
            App.Base.FocusTrap(level2Menu, false, level2MenuFocusable);
            setTimeout(function () { level2Menu.addClass("show"); }, 10);

        });

        level2Back.on("click", function () {
            const level1Item = $(".multi-menu-level-1.mobile").find("button").filter(`[aria-controls="${$(this).parent(".multi-menu-level-2").attr("id")}"]`);
            level2Menu.removeClass("show");
            menu.addClass("transition");
            setTimeout(function () {
                level2Menu.hide();
                menu.removeClass("transition");
                App.Base.FocusTrap(level2Menu, true, level2MenuFocusable);
                App.Base.FocusSend(level1Item[0]);
            }, speed);
        });
    }

    return {
        Desktop: Desktop,
        Shared: Shared,
        Mobile: Mobile
    };

})(jQuery);

$(function () {
    App.MultiMenu.Desktop();
    App.MultiMenu.Shared();
    App.MultiMenu.Mobile();
});